import React, { FC, useEffect, useState, useRef } from "react";
import { saveNotificationApi } from "./Notification.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import logo from "../../../assets/zampLogo.png";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FiAward, FiX } from "react-icons/fi";
export interface ICard {
  pointBalance?: any;
  getNotificationCount?: any;
  setNotificationCount?: any;
  notificationCount?: number;
}

export const PointNotificationModel: FC<ICard> = ({
  pointBalance,
  setNotificationCount,
  notificationCount,
}) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState("");
  const modalRef = useRef<HTMLDivElement>(null);
  const queryClient = useQueryClient();
  const type = "point";

  const mutation = useMutation(() => saveNotificationApi(auth?.panelistId, message, type), {
    onSuccess: (response: any) => {
      if (response.success) {
        queryClient.invalidateQueries(["saveNotificationApi"]);
      }
    },
    onError: () => {
      toast.error(t("point.notification.saving"));
    },
  });

  const handleModalClose = () => {
    mutation.mutate();
    setNotificationCount(notificationCount + 1);
    setIsModalVisible(false);
  };

  // Alert logic with localStorage
  useEffect(() => {
    const today = new Date();
    const day = today.getDay();
    const todayDateKey = today.toDateString();
    const hasShownModalDate = localStorage.getItem("pointModelShown");

    if ((day === 1 || day === 4) && hasShownModalDate !== todayDateKey) {
      let message = "";

      if (pointBalance === 0) {
        message = t("page.notification.start");
      } else if (pointBalance > 0 && pointBalance <= 500) {
        message = `${t("page.notification.Great")} ${pointBalance} ${t("page.notification.starKeept")}`;
      } else if (pointBalance > 500 && pointBalance <= 1500) {
        message = `${t("page.notification.fire")} ${pointBalance} ${t("page.notification.counting")}`;
      } else if (pointBalance > 1500 && pointBalance < 2500) {
        message = `${t("page.notification.Impressive")} ${pointBalance} ${t("page.notification.re")}`;
      } else if (pointBalance >= 2500 && pointBalance < 3000) {
        message = `${t("page.notification.Almost")} ${3000 - pointBalance} ${t("page.notification.away")}`;
      } else if (pointBalance >= 3000) {
        message = `${t("page.notification.Achievement")} ${pointBalance} ${t("page.notification.redeem")}`;
      }

      if (message) {
        const sendNotification = localStorage.getItem("sendNotification");
        if (sendNotification) {
          setMessage(message);
          setIsModalVisible(true);
          localStorage.setItem("pointModelShown", todayDateKey);

        }
      }
    }
  }, [pointBalance]);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        handleModalClose();
      }
    };

    if (isModalVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalVisible]);

  return (
    <div>
      {isModalVisible && (
        <div className="zs-backdrop" role="dialog" aria-modal="true" aria-labelledby="point-notification-title">
          {/* Modal Content */}
          <div ref={modalRef} className="zs-modal max-w-[460px]">
            <button onClick={handleModalClose} className="zs-icon-btn zs-modal-close" aria-label="Close">
              <FiX />
            </button>
            <div className="flex items-start gap-4 p-5 pr-14 sm:p-6 sm:pr-16">
              <span className="w-12 h-12 p-1.5 shrink-0 zs-logo-plate rounded-lg">
                <img src={logo} alt="Reward Icon" className="object-contain w-full h-full" />
              </span>
              <div className="min-w-0">
                <p id="point-notification-title" className="zs-eyebrow !mb-1">
                  <FiAward aria-hidden="true" />
                  Rewards update
                </p>
                <p className="text-[15px] leading-relaxed text-ink">{message}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
